import { Component, OnInit, Inject } from '@angular/core';
import { EmployeeService } from 'src/app/_services/employee.service';
import { ToastrService } from 'ngx-toastr';
import { FormBuilder, FormGroup, Validators, ValidationErrors } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { PortalUserRequest } from 'src/app/_model/request/PortalUserRequest';
import { AuthenticationService } from 'src/app/_services/authentication.service';
import { User } from 'src/app/_model/user';
import { PortaluserService } from 'src/app/_services/portaluser.service';
import { operations } from 'src/app/_model/constants';
import { RoleService } from 'src/app/_services/role.service';
import { Portaluser } from 'src/app/_model/portaluser';
import {Observable} from 'rxjs';
import {map, startWith} from 'rxjs/operators';
import {DialogCloseData} from '../../_model/models';
import {DIALOG_OPERATIONS} from '../../_utils/constants';
import {UtilityService} from '../../_helpers/utility.service';
import { MatCardModule } from '@angular/material/card';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatDialogModule } from '@angular/material/dialog';
declare var $: any
@Component({
  selector: 'app-portaluser-add',
  templateUrl: './portaluser-add.component.html',
  styleUrls: ['./portaluser-add.component.sass'],
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatCardModule,
    MatFormFieldModule,
    MatSelectModule,
    MatInputModule,
    MatAutocompleteModule,
    MatDialogModule
  ]
})
export class PortaluserAddComponent implements OnInit {
  employees: any;
  filteredEmployeeList: Observable<any[]>;
  portalUserAddForm: FormGroup;
  currentUser: User;
  portaluserrequest: PortalUserRequest = new PortalUserRequest();
  operationName: string;
  submitted = false;
  rolelist: any;
  selectedEmployeeId: number;
  selectedEmployeeEmail: string;
  selectedEmployee: any;

  constructor(private formBuilder: FormBuilder,
    private portaluserservice: PortaluserService,
    private employeeService: EmployeeService,
    private roleService: RoleService,
    private toastr: ToastrService,
    private route: ActivatedRoute,
    private router: Router,
    private utilityService: UtilityService,
    public dialogRef: MatDialogRef<PortaluserAddComponent>,
    @Inject(MAT_DIALOG_DATA) public data: Portaluser,
    private authService: AuthenticationService) {
    this.currentUser = authService.currentUserValue;
  }

  ngOnInit() {
    $('.role-multiple').select2();
    $('.js-example-basic-multiple').select2();
    this.createportaluserForm();
    if (Object.keys(this.data).length === 0) {
      this.operationName = operations.CREATE;
    } else {
      this.operationName = operations.UPDATE;

      this.portalUserAddForm.patchValue({
        username: this.data.username,
        email: this.data.email,
        employee: this.data.employee,
        roles: this.getRoleIdArray(this.data.roles)
     });
    }

    this.loadLookup();
  }

  loadLookup() {
    this.employeeService.getEmployeeList(-1).subscribe(result => {
      this.employees = result.responseData.items.sort((a, b) =>
          a.fullName.toLowerCase().localeCompare(b.fullName.toLowerCase(), 'tr')
      );
      this.filteredEmployeeList = this.portalUserAddForm.get('employee').valueChanges
          .pipe(
              startWith(''),
              map(value => this.filterEmployeeList(value))
          );
    },
     error => {
         this.toastr.error(error.error.msg, 'Hata');
     });

    this.roleService.listRoles().subscribe(result => {
      this.rolelist = result.responseData.items;
    });
  }

  private filterEmployeeList(value: any): string[] {
    let filterValue = '';
    if (value.hasOwnProperty('name')) {
      filterValue = this.utilityService.toTurkishLowerCase(value.name + ' ' + value.surname);
    } else {
      filterValue = this.utilityService.toTurkishLowerCase(value);
    }
    return this.employees.filter(employee => this.utilityService.toTurkishLowerCase(employee.fullName).includes(filterValue));
  }

  displayFn(employee: any): string | undefined {
    return employee ? employee.fullName : undefined;
  }

  getRoleIdArray(roles): any {
    const rolelist = [];
    for (let i = 0; i < roles.length; i++) {
      rolelist.push(roles[i].id);
    }
    return rolelist;
  }

  createportaluserForm() {
    this.portalUserAddForm = this.formBuilder.group({
      username: ['', [Validators.required]],
      email: ['', [Validators.email, Validators.required]],
      employee: [null, [Validators.required, this.utilityService.requireMatch]],
      roles:[]
    });
  }

  update() {
    this.portaluserrequest = {
      username: this.portalUserAddForm.controls.username.value,
      email: this.portalUserAddForm.controls.email.value,
      employeeId: this.portalUserAddForm.controls.employee.value.id,
      id: this.data.id,
      attribute1:'',
      attribute2:'',
      attribute3:'',
      attribute4:'',
      attribute5:'',
      attribute6:'',
      attribute7:'',
      attribute8:'',
      attribute9:'',
      attribute10:'',
      roleIds: this.portalUserAddForm.controls.roles.value
    }

    this.portaluserservice.updateUser(this.portaluserrequest).subscribe(result => {
      this.toastr.success('Kullanıcı güncellendi.', 'Başarılı');
      this.portalUserAddForm.enable();
      this.dialogRef.close(new DialogCloseData(DIALOG_OPERATIONS.UPDATE, result.responseData.item));
    }, error => {
      this.toastr.error(error.error.msg, 'Hata');
      this.portalUserAddForm.enable();
    });

  }

  create() {
    if (!this.portalUserAddForm.valid) {
      this.getFormValidationErrors();
      return;
    }
    this.portalUserAddForm.disable();
    this.portaluserrequest.username = this.portalUserAddForm.controls.username.value;
    this.portaluserrequest.email = this.portalUserAddForm.controls.email.value;
    this.portaluserrequest.employeeId = this.portalUserAddForm.controls.employee.value.id;
    this.portaluserrequest.attribute1 = '';
    this.portaluserrequest.attribute2 = '';
    this.portaluserrequest.attribute3 = '';
    this.portaluserrequest.attribute4 = '';
    this.portaluserrequest.attribute5 = '';
    this.portaluserrequest.attribute6 = '';
    this.portaluserrequest.attribute7 = '';
    this.portaluserrequest.attribute8 = '';
    this.portaluserrequest.attribute9 = '';
    this.portaluserrequest.attribute10 = '';
    this.portaluserrequest.roleIds = this.portalUserAddForm.controls.roles.value;

    this.portaluserservice.saveUser(this.portaluserrequest).subscribe(result => {
      this.toastr.success('Kullanıcı oluşturuldu.', 'Başarılı');
      this.portalUserAddForm.enable();
      this.dialogRef.close(new DialogCloseData(DIALOG_OPERATIONS.CREATE, result.responseData.item));
    }, error => {
      this.toastr.error(error.error.msg, 'Hata');
      this.portalUserAddForm.enable();
    });

  }

  getFormValidationErrors() {
    Object.keys(this.portalUserAddForm.controls).forEach(key => {

      const controlErrors: ValidationErrors = this.portalUserAddForm.get(key).errors;
      if (controlErrors != null) {
        Object.keys(controlErrors).forEach(keyError => {
          console.log('Key control: ' + key + ', keyError: ' + keyError + ', err value: ', controlErrors[keyError]);
        });
      }
    });
  }

  createOrUpdatePortalUser() {
    this.submitted = true;
    if (this.portalUserAddForm.invalid) {
      this.getFormValidationErrors();
        return;
    }
    if (this.operationName === operations.UPDATE) {
        this.update();
    } else {
        this.create();
    }
  }

  closeModal() {
      this.dialogRef.close();
  }

    /**
     * secilen calisana ait emaili cekip formdaki email alanina yapistiriyoruz. Kullanici isterse degistirir
     */
  employeeChange(e) {
    this.portalUserAddForm.controls['email'].setValue(e.option.value.email);
  }
}
